import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'shards-react'

import '../../invite-accept-screen.css'

export default function DisapprovedSolicitationMessage({ goToLoginPage }) {
    DisapprovedSolicitationMessage.propTypes = {
        goToLoginPage: PropTypes.func,
    }

    return (
        <Fragment>
            <i
                className="material-icons invite-accept--icon--disapproved"
                style={{
                    fontSize: 75,
                }}
            >
                cancel
            </i>
            <p>Olá.</p>
            <p>Infelizmente, sua solicitação para participar no projeto foi negada. </p>
            <Button id="invite-accept--back-button" onClick={goToLoginPage}>
                Acessar o portal
            </Button>
        </Fragment>
    )
}
